import { html } from "lit-element";
import { SharedStyles } from "../../../../styles/shared-styles";
import { ModuleBase } from "../../ModuleBase/ModuleBase";
import { getCanvasA4Size } from "../../helpers";
import { getImageUrlInBase64 } from "../../../../data/images";
import { insert_image } from "./drawing-image-icons";

export class DrawImageModule extends ModuleBase {
	Activate() {
		this.canvas.defaultCursor = "crosshair";
		this.__onDraw = this.onDraw.bind(this); //save reference to bound function to be able to deactivate
		this.canvas.on("mouse:down", this.__onDraw);
		return this;
	}

	Deactivate() {
		this.canvas.setCursor(this.canvas.defaultCursor);
		this.canvas.off("mouse:down", this.__onDraw);
	}

	render() {
		return html`
            ${SharedStyles}
            <style>
                input[type="radio"] {
                    display: none;
                }

      			.img-selector {               
                    display: flex;
                    flex-direction: row;
                    flex-wrap: wrap;
                    overflow-y: auto;
                    width: 40px;
                    height:40px;
                }

                .img {
					background-image: url(${this._item.url});
                    background-size: cover;
                    background-position: center;
                    background-repeat: no-repeat;
                    width: 36px;
                    height: 36px;
                }
            </style>     
            <div class="img-selector">                      
            	<div class="img"> </div>
         	</div>`;
	}

	onDraw(o) {
		this.Draw(this.canvas.getPointer(o.e));
		this.fireOnDraw();
	}

	Draw(pointer) {
		const canvas = this.canvas;
		getImageUrlInBase64(this._item.id).then(urlInBase64 => {
			fabric.Image.fromURL(urlInBase64, img => {
				const origSize = getCanvasA4Size();
				const hRatio = origSize.w / img.width;
				const vRatio = origSize.h / img.height;
				const ratio = Math.min(hRatio, vRatio);
				img.scale(ratio / 3);
				img.set({
					width: img.width,
					height: img.height,
					originX: "left",
					originY: "top",
					selectable: true,
					transparentCorners: false
				});
				img.set({ left: pointer.x, top: pointer.y });
				img.setCoords();
				canvas.add(img);
				canvas.renderAll();
			});
		});
	}

	_createImageUrl(img) {
		const blob = new Blob([img.data], { type: img.dataMimeType || mimeType });
		return URL.createObjectURL(blob);
	}

	static get properties() {
		return {
			_items: Array,
			selectedValue: Number,
			inspId: String
		};
	}

	constructor(canvas, image) {
		super();
		this.canvas = canvas;
		this._item = image;
	}
}

window.customElements.define("inspx-draw-image-module", DrawImageModule);
